export default "__VITE_ASSET__cm6X$Q9I__"